export default __webpack_public_path__ + "img/check-light.bd970cde.svg";